export const  IMPORT_SUCCESS ="";
export const  IMPORT_ERROR ="";
export const  IMPORT_FAILED="";
export const  IMPORT_BOM_CHECKOUT_ERROR ="BOM checked out";
export const  IMPORT_ACCESS_ERROR ="Insufficient access";
export const  IMPORT_SUCCESS_SOFT_DELETE ="Soft Delete";
export const  IMPORT_DATA_ERROR="View error file for details";
export const  IMPORT_SUCCESS_WARNING="View warning file for details";
export const  IMPORT_SUCCESS_PARTIAL="View error file for details";
export const  IMPORT_SUCCESS_SOFTDELETED="Soft Delete";
export const  IMPORT_INVALID_FILE_ERROR="File is not valid";
export const  IMPORT_FAIL_EXCEED_MAX_LIMIT=" Xlsx file exceed max row limit";
export const  IMPORT_BAD_REQUEST_ERROR="Retry, or Contact Administrator";
export const  IMPORT_FILE_NOT_FOUND_ERROR="Retry, or Contact Administrator";
export const  IMPORT_RUNTIME_ERROR="Retry, or Contact Administrator";
export const  IMPORT_SCHEMA_ERROR="Invalid Schema field type";
export const  IMPORT_CONCURRENT_ERROR="Retry, or Contact Administrator";